import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { ResponseData } from 'src/app/helper/interface/response';

@Injectable({
  providedIn: 'root'
})
export class MasterApiService {
  constructor(public http: HttpClient) { }
  getApi(tbl: string) {
    return '';
  }
  getById(tbl: string, id: string | number): Promise<ResponseData> {
    return lastValueFrom(this.http.get(`${this.getApi(tbl)}/getById/${tbl}/${id}`))
  }
  searchAgent(terms: any) {
    return lastValueFrom(this.http.get(`search/staff/${terms}`))
  }
  getFullData(tbl: string, cond: any = '', isFull = false, lazy = {}) {
    //0let query: string = '';
    //Array.isArray(cond) ? cond.map(a => query = query + '/' + a) : '';
    const tbl_ext = `/` + JSON.stringify(cond);
    const lasyP = isEmptyObj(lazy) ? '' : '/' + JSON.stringify(lazy);
    if (isFull) {
      return lastValueFrom(this.http.get(`${this.getApi(tbl)}/getfull/${tbl}${tbl_ext}${lasyP}`,))
    } else {
      return lastValueFrom(this.http.get(`${this.getApi(tbl)}/get/${tbl}${tbl_ext}${lasyP}`));
    }
  }

  saveData(tbl: string, data: any) {
    return lastValueFrom(this.http.post(`${this.getApi(tbl)}/saveData/${tbl}`, data))
  }

  getMobileApp(lazy: any = {}) {
    const lasyP = isEmptyObj(lazy) ? '' : '/' + JSON.stringify(lazy);
    return lastValueFrom(this.http.get(`app/getList${lasyP}`,))
  }

  generateEmail(id: string | number, data: any) {
    return lastValueFrom(this.http.post(`genEmail/${id}`, data))
  }

  exportData(tName = '', data: any = []) {
    data = JSON.stringify(data);
    return lastValueFrom(this.http.post(`exportData/${tName}`, data, { responseType: 'blob' }))
  }
  sendEmail(data: Array<any>) {
    if (!Array.isArray(data)) {
      data = [data];
    }
    return lastValueFrom(this.http.post(`sendEmail`, data))
  }
  search(tbl: string, terms: any) {
    return lastValueFrom(this.http.get(`search/${tbl}/${terms}`))
  }

  searchInvoice(tbl: string, terms: any) {
    return lastValueFrom(this.http.get(`invoice/search/${tbl}${terms}`))
  }

  savePrescription(data: any) {
    return lastValueFrom(this.http.post(`medicine/saveMedicineTemplate`, data));
  }
  prescriptionList(ev: any) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`medicine/getList`));
  }
  logList(ev: any) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`sms_transaction/getList/${lasyP}`));
  }

  msgLogGetById(id: any) {
    return lastValueFrom(this.http.get(`sms_transaction/getById/${id}`));
  }

  prescriptionLists() {
    // const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`medicine/getList`));
  }
  prescriptionGetById(id: any) {
    return lastValueFrom(this.http.get(`medicine/getDataByTemplate/${id}`));
  }
  PrescriptionDelete(id: any) {
    return lastValueFrom(this.http.delete(`medicine/deleteTemplate/${id}`));
  }
  PrescriptionItemDelete(id: any) {
    return lastValueFrom(this.http.delete(`medicine/deleteTemplateItem/${id}`));
  }
  WhatsappMsg(data: any) {
    return lastValueFrom(this.http.post(`whatsapp/send`, data));
  }
  goToExcel(id: any) {
    return lastValueFrom(this.http.get(`payrollReport/getReportDetails/${id}`,
      {
        responseType: 'blob',
      }));
  }
  getDocContent(eventName: any, id: any) {
    return lastValueFrom(this.http.get(`genDocContent/${eventName}/${id}`));
  }
  getAllBackup() {
    return lastValueFrom(this.http.get(`getAllBackup`));
  }
  runBackup() {
    return lastValueFrom(this.http.get(`runBackUp`));
  }
  restoreBackup(name) {
    return lastValueFrom(this.http.get(`restoreBackUp/${name}`));
  }
}
